import * as React from 'react';

import Rive from '@rive-app/react-canvas';

import {Stack} from '../../layout/stack/stack';
import {Body} from '../../typography/body';

import styles from './feedback-page-layout.module.css';

type Props = {
    title: string;
    subtitle: string;
    animationSrc: string;
    formComponent: React.ReactNode;
};

export function FeedbackPageLayout(props: Props) {
    return (
        <Stack spacing={32} alignItems='center'>
            <div className={styles.content}>
                <div className={styles['animation-container']}>
                    <Rive src={props.animationSrc} />
                </div>
                <Stack spacing={32}>
                    <Body useDoyle={true} size='xlarge' isBold={true} textAlign='center'>
                        {props.title}
                    </Body>
                    <Body textAlign='center'>{props.subtitle}</Body>
                </Stack>
            </div>
            {props.formComponent}
        </Stack>
    );
}
